<template lang="pug">
	div.notificacion(:class="clase", :style="(notificacion.URI) ? {'cursor' : 'pointer'} : {}", @click="go()")
		.imagen(v-if="notificacion.Imagen")
			div.imagenCuadrada(:style="{backgroundImage: 'url(' + notificacion.Imagen + ')'}")
		.icono(v-else-if="notificacion.Icono")
			span.fa(:class="notificacion.Icono")
		.icono(v-else)
			span.fa.fa-bell
		.contenido
			.titulo {{notificacion.Titulo}}
			.descripcion {{notificacion.Descripcion}}
			.fecha {{notificacion.FechaCreacion | moment('DD-MM-YYYY HH:mm:ss')}}
		.acciones
			div(@click="descartar($event)")
				span.fa.fa-trash
</template>

<script>
export default {
	props: ['notificacion', 'index', 'total'],
	data () {
		return {
			cerrando: false,
			estilo: {
				transform: 'translateY(' + (this.index * 50) + 'px)'
			}
		}
	},
	watch: {
		index: function (newVal) {
			this.estilo = {
				transform: 'translateY(' + (this.index * 50) + 'px)'
			}
		}
	},
	computed: {
		clase () {
			if (!this.notificacion.FechaMostrada) {
				return 'nueva'
			}

			const dif = Math.floor(new Date().getTime() / 1000) - this.notificacion.FechaMostrada

			if (dif < 5) {
				return 'nueva'
			}

			return ''
		}
	},
	methods: {
		descartar (ev) {
			ev.preventDefault()
			ev.stopPropagation()
			this.$emit('descartar', this.notificacion.NotificacionID)
		},
		go () {
			if (!this.notificacion.URI) {
				return
			}

			this.$router.push(this.notificacion.URI)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>


<style scoped>
.notificacion.nueva {
	background-color: #E4E9F1 !important;
}
.notificacion.noBorde {
	border-top: 0;
}
.notificacion {
	position: relative;
	display: flex;
	flex-direction: row;
	width: 348px;
	justify-content: flex-start;
	align-items: stretch;
	align-content: stretch;
	background-color: white;
	border-bottom: 1px solid #e0e0e0;
	color: #333333;
	transition-duration: 500ms;
	transition-property: transform;
	transition-timing-function: ease-in-out;
}
.notificacion > .imagen {
	min-height: 50px;
	min-width: 50px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 15%;
	align-self: stretch;
}

.notificacion > .icono {
	min-height: 50px;
	min-width: 50px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 15%;
	align-self: center;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	opacity: 0.5;
}

.notificacion > .icono > span {
	font-size: 1.8em;
}

.notificacion > .contenido {
	min-height: 50px;
	width: 100%;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 100%;
	align-self: stretch;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.notificacion > .contenido .titulo {
	font-weight: bold;
	font-size: 1.1em;
}

.notificacion > .contenido .descripcion {
	font-size: 0.9em;
}

.notificacion > .contenido .fecha {
	font-size: 0.8em;
	color: #aaaaaa;
}


.notificacion > .acciones {
	min-height: 50px;
	min-width: 30px;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 5%;
	align-self: stretch;
	display: flex;
	flex-direction: column;
	/* background-color: #f0f0f0; */
	text-align: center;
	font-size: 1em;
	/* border-left: 1px solid #e0e0e0; */
}

.notificacion > .acciones > div {
	cursor: pointer;
	text-align: center;
	opacity: 0.5;
	padding-top: 5px;
}

.notificacion > .acciones > div:hover {
	opacity: 1;
}
</style>





// WEBPACK FOOTER //
// src/modulos/core/vue/components/notificaciones/notificacion.vue